import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/i18n';
import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
